import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';
import moment from 'moment';
import Tooltip from 'material-ui/Tooltip';

import IconButton from 'material-ui/IconButton';
import Button from 'material-ui/Button';
import Menu, { MenuItem } from 'material-ui/Menu';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import CreateNewFolder from '@material-ui/icons/CreateNewFolder';
import AccessTime from '@material-ui/icons/AccessTime';
import Settings from '@material-ui/icons/Settings';
import RemoveRedEye from '@material-ui/icons/RemoveRedEye';
import MessageIcon from '@material-ui/icons/Comment';
import ShortText from '@material-ui/icons/ShortText';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import FormatAlignLeft from '@material-ui/icons/FormatAlignLeft';
import { ListItemIcon, ListItemText } from 'material-ui/List';

import * as CalendarState from '../../../state/reducer/calendar/calendar';
import * as AppState from '../../../state/reducer/app/appState';
import DialogFactory from '../../factory/DialogFactory';
import CalendarCollapseHeader from './CalendarCollapseHeader';
import CalendarMessagingDrawer from './CalendarMessagingDrawer';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';
import * as Authorization from '../../../lib/authorization';
import * as Utils from '../../../lib/designerUtils';
import CONF from '../../../api/config';

import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';

import Console from '../../../lib/debug';
import FeatureFlag from '../../../v5/features/components/FeatureFlag';
import { FEATURES } from '../../../v5/features/components/constants';
import PrimaryButton from '../../common/component/PrimaryButton';

const AUTO_PUBLISH_PROGRAM_TYPES = [
    ProgramTypes.TYPES.TEAM,
    ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR
];
const PUBLISH_ALL_PROGRAM_TYPES = [
    ProgramTypes.TYPES.TEAM,
    ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.CALENDAR
];
const MONTH_TYPES = [
    ProgramTypes.TYPES.TEAM,
    ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.CALENDAR
];

const NOW = Date.now();

const URL_TEAM_TYPE_STRING = 'team';
const URL_PROGRAM_TYPE_STRING = 'program';

class CalendarHeader extends Component {
    state = {
        publishAllDialogOpen: false,
        anchorEl: null,
        messageDrawerOpen: false
    };

    toggleAutoPublishSettings = () => {
        CalendarState.openAutoPublishSettings();

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Secondary nav',
            ctaText: 'Auto Publish icon'
        });
    };

    autoPublishButton = () => {
        if (!AUTO_PUBLISH_PROGRAM_TYPES.includes(this.props.programType))
            return null;
        return (
            <Tooltip title="Auto-Publish">
                <IconButton
                    color="inherit"
                    aria-label="Auto Publish Settings"
                    onClick={this.toggleAutoPublishSettings}
                >
                    <AccessTime />
                </IconButton>
            </Tooltip>
        );
    };

    toggleLibraryDrawer = () => {
        CalendarState.toggleSideNav(!this.props.sideNavOpen);

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Secondary nav',
            ctaText: 'Add From Library icon'
        });
    };

    libraryDrawerButton = () => {
        return (
            <Tooltip title="Add from library">
                <IconButton
                    color="inherit"
                    aria-label="Toggle Library"
                    onClick={this.toggleLibraryDrawer}
                >
                    <CreateNewFolder />
                </IconButton>
            </Tooltip>
        );
    };

    navigateToSettingsPage = () => {
        let typeString, id;

        if (ProgramTypes.isTeamCalendar(this.props.programType)) {
            typeString = 'team';
            id = this.props.team && this.props.team.group_id;
        } else if (ProgramTypes.isProgram(this.props.programType)) {
            typeString = 'program';
            id = this.props.programId;
        }

        let url = `${CONF.URL_COACHHEROIC}/${typeString}/settings/${id}`;

        if (typeString === URL_TEAM_TYPE_STRING) {
            url = `${CONF.BASE_URL_TEAMS}/team/${id}/settings`;
        } else if (typeString === URL_PROGRAM_TYPE_STRING) {
            url = `${CONF.BASE_URL_TEAMS}/program/${id}/settings`;
        }

        return (window.location.href = url);
    };

    settingsButton = () => {
        let settingsTypes = [ProgramTypes.TYPES.FIXED, ProgramTypes.TYPES.TEAM];
        if (!settingsTypes.includes(this.props.programType)) return null;
        return (
            <Tooltip title="Settings">
                <IconButton
                    color="inherit"
                    aria-label="Settings"
                    onClick={this.navigateToSettingsPage}
                >
                    <Settings />
                </IconButton>
            </Tooltip>
        );
    };

    onClickViewOptions = event => {
        this.setState({ anchorEl: event.currentTarget });

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Secondary nav',
            ctaText: 'View Options icon'
        });
    };

    toggleCalendarInstructions = () => {
        CalendarState.toggleCalendarInstructions();
        this.handleViewOptionsClose();
    };

    toggleCalendarBlockNames = () => {
        CalendarState.toggleCalendarBlockNames();
        this.handleViewOptionsClose();
    };

    handleViewOptionsClose = () => {
        this.setState({ anchorEl: null });
    };

    viewOptionsButton = () => {
        const { anchorEl } = this.state;
        let calendarInstructionLabel = this.props.calendarInstructionsEnabled
            ? 'Hide Instructions'
            : 'Show Instructions';
        let calendarBlockNamesLabel = this.props.calendarBlockNamesEnabled
            ? 'Hide Block Titles'
            : 'Show Block Titles';

        return (
            <div>
                <Tooltip title="View Options">
                    <IconButton
                        color="inherit"
                        onClick={this.onClickViewOptions}
                    >
                        <RemoveRedEye />
                    </IconButton>
                </Tooltip>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleViewOptionsClose}
                    className="th-menu"
                >
                    <MenuItem onClick={this.toggleCalendarInstructions}>
                        <ListItemIcon>
                            <ShortText />
                        </ListItemIcon>
                        <ListItemText
                            inset
                            primary={calendarInstructionLabel}
                        />
                    </MenuItem>
                    <MenuItem onClick={this.toggleCalendarBlockNames}>
                        <ListItemIcon>
                            <FormatAlignLeft />
                        </ListItemIcon>
                        <ListItemText inset primary={calendarBlockNamesLabel} />
                    </MenuItem>
                </Menu>
            </div>
        );
    };

    publishAllShowConfirmDialog = () => {
        this.setState({
            publishAllDialogOpen: true
        });

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Secondary nav',
            ctaText: 'Publish All'
        });
    };

    publishAllCancel = () => {
        this.setState({
            publishAllDialogOpen: false
        });
    };

    publishAllSave = () => {
        this.setState({
            publishAllDialogOpen: false
        });

        if (!Authorization.publishSession.isAllowed()) {
            return AppState.showUnauthorizedDialog();
        }

        return CalendarState.publishAllProgramWorkouts();
    };

    publishAllDialog = () => {
        return (
            <DialogFactory
                enabled={this.state.publishAllDialogOpen}
                handleClose={this.publishAllCancel.bind(this)}
                handleSave={this.publishAllSave.bind(this)}
                header="Publish All?"
                text="Are you sure you want to publish all sessions?"
                cancelButtonTitle="Cancel"
                saveButtonTitle="Ok"
            />
        );
    };

    publishAllButton = () => {
        if (!PUBLISH_ALL_PROGRAM_TYPES.includes(this.props.programType))
            return null;

        return (
            <PrimaryButton
                className="publish-all-button"
                disabled={!this.props.publishAllEnabled}
                variant="raised"
                aria-label="Publish All"
                onClick={this.publishAllShowConfirmDialog}
            >
                Publish All
            </PrimaryButton>
        );
    };

    messageButton = () => {
        if (!this.props.messagingButtonText) {
            return null;
        }

        return (
            <Button
                className="messaging-button"
                variant="raised"
                aria-label="Message Team"
                onClick={this.openMessageDrawer}
            >
                <MessageIcon style={{ marginRight: 5, color: 'white' }} />
                {this.props.messagingButtonText}
            </Button>
        );
    };

    openMessageDrawer = () => {
        this.setState({ messageDrawerOpen: true });

        if (this.props.messagingButtonText === 'Message Athlete') {
            SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
                sources: 'Web app',
                ctaLocation: 'Secondary nav',
                ctaText: 'Message Athlete'
            });
        }
    };

    closeMessageDrawer = () => {
        this.setState({ messageDrawerOpen: false });
    };

    previousMonth = () => {
        let month = this.props.month - 1;
        let year = this.props.year;

        if (month < 1) {
            month = 12;
            year--;
        }

        this.navigate(year, month);
    };

    previousMonthButton = () => {
        if (!MONTH_TYPES.includes(this.props.programType)) return null;

        return (
            <IconButton
                color="inherit"
                aria-label="Previous Month"
                onClick={this.previousMonth}
            >
                <KeyboardArrowLeft />
            </IconButton>
        );
    };

    programDetails = () => {
        if (!ProgramTypes.isProgram(this.props.programType)) return null;

        let weeks = parseInt(this.props.programLength / 7, 10);

        return <span>{weeks} Week Program</span>;
    };

    nextMonth = () => {
        let month = this.props.month + 1;
        let year = this.props.year;

        if (month > 12) {
            month = 1;
            year++;
        }

        this.navigate(year, month);
    };

    nextMonthButton = () => {
        if (!MONTH_TYPES.includes(this.props.programType)) return null;

        return (
            <IconButton
                color="inherit"
                aria-label="Next Month"
                onClick={this.nextMonth}
            >
                <KeyboardArrowRight />
            </IconButton>
        );
    };

    currentMonthText = () => {
        if (!MONTH_TYPES.includes(this.props.programType)) return null;

        let month = this.props.month;
        let monthName = moment(month, 'MM').format('MMMM');

        return (
            <Typography variant="subheading" color="inherit">
                {monthName} {this.props.year}&nbsp;&nbsp;
            </Typography>
        );
    };

    jumpToToday = () => {
        let month = this.currentMonth();
        let year = moment().year();
        let day = moment().day();
        this.navigate(year, month, day);
    };

    navigate = (year, month, day) => {
        let { programType, programId } = this.props;
        if (ProgramTypes.isProgram(programType)) return;
        const dayId = `?id=${year}_${month}_${day}`;

        if (ProgramTypes.isInvitedAthleteCalendar(programType)) {
            const inviteId = this.props.athleteId;
            return AppState.navigate(
                `/athlete/invite/${inviteId}/${year}/${month}${dayId}`
            );
        }

        if (ProgramTypes.isCoachAthleteCalendar(programType)) {
            programId = this.props.athleteId;
        }
        let programTypeString = ProgramTypes.convertToString(programType);
        return AppState.navigate(
            `/${programTypeString}/${programId}/${year}/${month}${dayId}`
        );
    };

    currentMonth = () => {
        return moment().month() + 1;
    };

    currentYear = () => {
        return moment().year();
    };

    jumpToTodayButton = () => {
        if (!MONTH_TYPES.includes(this.props.programType)) return null;
        if (
            this.currentMonth() == this.props.month &&
            this.props.year == this.currentYear()
        )
            return null;

        return (
            <Button
                color="inherit"
                variant="raised"
                aria-label="Jump To Today"
                className="jump-to-today"
                onClick={this.jumpToToday}
            >
                Today
            </Button>
        );
    };

    getProgramId = () =>
        ProgramTypes.getAthleteValue(
            this.props.programType,
            this.props.athleteId,
            this.props.programId
        );

    render() {
        Console.render('CalendarHeader');
        if (!this.props.calendarHeaderEnabled) return null;
        let programId = this.getProgramId();
        return (
            <div className="calendar-header">
                {this.publishAllDialog()}
                <Toolbar>
                    {this.programDetails()}
                    {this.previousMonthButton()}
                    {this.nextMonthButton()}
                    {this.currentMonthText()}
                    {this.jumpToTodayButton()}
                    <Typography
                        variant="title"
                        color="inherit"
                        className="flex"
                    />
                    <FeatureFlag feature={FEATURES.WEB_MESSAGING_V1}>
                        {this.messageButton()}
                    </FeatureFlag>
                    {this.publishAllButton()}
                    {this.viewOptionsButton()}
                    {this.libraryDrawerButton()}
                    {this.autoPublishButton()}
                    {this.settingsButton()}
                </Toolbar>
                <CalendarCollapseHeader
                    programId={programId}
                    programType={this.props.programType}
                />
                {this.props.messagingButtonText && (
                    <CalendarMessagingDrawer
                        onClose={this.closeMessageDrawer}
                        path={this.props.messagingPath}
                        messageDrawerOpen={this.state.messageDrawerOpen}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    // Find the sessions currently displayed on the calendar
    let days = _.values(state.calendar.dayTree);
    let sessionKeys = _.reduce(days, (list, day) => list.concat(day.items), []);
    let sessionTree = state.calendar.sessionTree;
    let sessions = _.map(sessionKeys, key => sessionTree[key]);
    sessions = _.without(sessions, undefined);
    let dayList = state.calendar.dayList;
    let publishAllEnabled = _.any(sessions, session => {
        let dayKey = Utils.getDayKey(session.data);
        return !session.data.published && dayList.includes(dayKey);
    });
    const team = state.calendar.infoTree.team;
    let messagingPath = `${CONF.ADAPTER}/messaging/`;
    let messagingButtonText = false;
    if (
        team.type === ProgramTypes.TYPES.TEAM ||
        team.type === ProgramTypes.TYPES.CALENDAR
    ) {
        messagingPath += `team/${team.group_id}?timestamp=${NOW}`;
        messagingButtonText = 'Message Team';
    }
    if (team.type === ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR) {
        messagingPath += `direct/${
            state.calendar.infoTree.athleteId
        }?timestamp=${NOW}`;
        messagingButtonText = 'Message Athlete';
    }

    return {
        ...ownProps,
        calendarHeaderEnabled: state.nav.calendarHeaderEnabled,
        sideNavOpen: state.calendar.uiTree.calendarSideNavOpen,
        programType: state.calendar.infoTree.programType,
        programId: state.calendar.infoTree.programId,
        athleteId: state.calendar.infoTree.athleteId,
        team: team,
        publishAllEnabled,
        calendarBlockNamesEnabled:
            state.calendar.uiTree.calendarBlockNamesEnabled,
        calendarInstructionsEnabled:
            state.calendar.uiTree.calendarInstructionsEnabled,
        month: state.calendar.infoTree.month,
        year: state.calendar.infoTree.year,
        programLength: state.calendar.infoTree.programLength,
        messagingPath: messagingPath,
        messagingButtonText: messagingButtonText
    };
};

export default connect(mapStateToProps)(CalendarHeader);



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarHeader.jsx